var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "#9A9A9A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M2.1 8.3L2.1 19.2C2.1 19.6 1.8 20 1.3 20H1C0.6 20 0.2 19.6 0.2 19.2L0.2 8.3C0.2 7.9 0.6 7.5 1 7.5H1.3C1.8 7.5 2.1 7.9 2.1 8.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M6.9 4.5L6.9 19.2C6.9 19.6 6.6 20 6.1 20H5.8C5.4 20 5 19.6 5 19.2L5 4.5C5 4 5.4 3.7 5.8 3.7H6.1C6.6 3.7 6.9 4 6.9 4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M17 1.6V19.2C17 19.6 16.6 20 16.2 20H15.9C15.4 20 15.1 19.6 15.1 19.2L15.1 1.6C15.1 1.2 15.4 0.8 15.9 0.8L16.2 0.8C16.6 0.8 17 1.2 17 1.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12.2 11.2V19.2C12.2 19.6 11.8 20 11.4 20H11.1C10.6 20 10.3 19.6 10.3 19.2V11.2C10.3 10.8 10.6 10.4 11.1 10.4H11.4C11.8 10.4 12.2 10.8 12.2 11.2Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.9fe61a3a.svg";
export { ForwardRef as ReactComponent };